export default __webpack_public_path__ + "static/media/cart.6d96ebba.png";